'use client';

import React from 'react';
import 'swiper/css';
import 'swiper/css/navigation';
import { B2BContent } from '@/lib/types/customer/B2BContent';

type ShopsCarouselProps = {
  params?: Record<string, string>;
  sectionData?: any;
  lang: 'en' | 'de';
  content?: B2BContent['featured_shops'];
};

export default function FeaturedShopsGrid({
  lang,
  content,
}: ShopsCarouselProps) {
  return (
    <div className="container">
      <div className="header">
        <h2 className="text-h3 font-bold md:text-h2">
          {content?.title?.[lang] ?? ''}
        </h2>
      </div>
      <div className="grid grid-cols-12 gap-3">
        {content?.shops && content?.shops?.length > 0
          ? content?.shops.map(
              (
                storeBrand: B2BContent['featured_shops']['shops'][0],
                idx: number
              ) => (
                <div
                  key={idx}
                  className="col-span-4 flex items-center justify-center py-3 md:col-span-2 lg:col-span-1"
                >
                  <div
                    title={storeBrand.name}
                    className="flex h-24 w-full items-center justify-center rounded-lg bg-white p-1 shadow-md transition-all duration-200 hover:shadow-lg"
                  >
                    <div
                      className="h-[92%] w-[92%] bg-contain bg-center bg-no-repeat"
                      style={{ backgroundImage: `url(${storeBrand.img_url})` }}
                    ></div>
                  </div>
                </div>
              )
            )
          : null}
      </div>
    </div>
  );
}
